import React, { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';

import styles from './ProductCardDiscount.module.scss';

type PropsType = {
  discountPercentage: string;
} & Omit<ComponentPropsWithoutRef<'div'>, 'children'>;

export default function ProductCardDiscount({
  className,
  discountPercentage,
  ...props
}: PropsType): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container, className)} {...props}>
      <span>{t('UP_TO')}</span>
      <div className={styles.wrapper}>
        <Trans
          i18nKey="DISCOUNT_PERCENTAGE"
          values={{ amount: discountPercentage }}
        />
      </div>
    </div>
  );
}
